module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Logged in with UPS successfully!":"Erfolgreich mit UPS eingeloggt!","An error occurred!":"Es ist ein Fehler aufgetreten!","Login with UPS failed":"Login mit UPS ist fehlgeschlagen","Processing Login with UPS":"Login per UPS wird verarbeitet"}}')
  delete Component.options._Ctor
}
